module.exports = __webpack_public_path__ + "static/media/blue-lagoon.f3936212.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Header/images/backgrounds/small/blue-lagoon.png
 ** module id = 190
 ** module chunks = 0
 **/